import { FormatString } from '@components/FormatString';
import { useMemo } from 'react';
import type { SearchOverviewProps } from './types';

export const SearchOverview: React.FC<SearchOverviewProps> = ({ page, searchTerm }) => {
  const resultsTextFormatString = useMemo(() => {
    const { resultsTextSingular, resultsTextPlural } = page;
    return page.results?.length === 1 ? resultsTextSingular : resultsTextPlural;
  }, [page.results?.length, page]);

  if (page.results?.length === 0) {
    return null;
  }

  return (
    <h3>
      <FormatString
        formatString={resultsTextFormatString}
        replacementInfo={{
          Count: page.results.length,
          SearchString: searchTerm,
        }}
      />
    </h3>
  );
};
